<template>
  <header>
    <div class="flex justify-between w-full xl:px-2 bg-white z-50" :class="{ 'fixed xl:relative top-0': isShowMenu }">
      <div class="flex items-center p-1 xl:p-3">
        <router-link :to="{ name: 'Index' }" v-if="authorized && !ai_sid && !ai_uuid" class="cursor-pointer hidden xl:inline-block">
          <img class="block h-auto mx-auto object-contain" src="@/assets/image/gept/backRouter.png" alt="">
        </router-link>
        <!-- <a v-if="authorized && !ai_sid && !ai_uuid" class="bg-red-main-ai text-white p-2 px-3 hidden xl:inline-block mb-2 text-sm cursor-pointer" @click.prevent="logout2()">LOGOUT</a> -->
        <div v-if="authorized && ai_sid">
          <!-- <a @click.native="logout()" :href="levelPath" class="text-sm hover:underline inline-block">返回練習清單</a>
          <span class="mx-2">|</span> -->
          <!-- <a @click.native="logout()"  :href="urlPath" class="text-sm hover:underline inline-block">學習記錄</a> -->
        </div>
        <div class="ham-outer xl:hidden" v-if="authorized && !ai_sid && !ai_uuid">
          <svg class="ham hamRotate ham1" :class="{ 'active': isShowMenu }" viewBox="0 0 100 100" width="80" @click="isShowMenu = !isShowMenu">
            <path class="line top" d="m 30,33 h 40 c 0,0 9.044436,-0.654587 9.044436,-8.508902 0,-7.854315 -8.024349,-11.958003 -14.89975,-10.85914 -6.875401,1.098863 -13.637059,4.171617 -13.637059,16.368042 v 40" />
            <path class="line middle" d="m 30,50 h 40" />
            <path class="line bottom" d="m 30,67 h 40 c 12.796276,0 15.357889,-11.717785 15.357889,-26.851538 0,-15.133752 -4.786586,-27.274118 -16.667516,-27.274118 -11.88093,0 -18.499247,6.994427 -18.435284,17.125656 l 0.252538,40" />
          </svg>
        </div>
        <!-- <p class=" font-semibold">Hi, peggy</p> -->
      </div>

      <div class="flex items-center justify-center py-3">
        <img class="block h-auto mx-auto object-contain mr-2" src="@/assets/image/gept/logo_header.png" alt="">
        <p class="gept_main_color_light text-xl font-black">GEPT 模擬練習</p>
      </div>

      <div>
        <div class="items-center font-black p-1 xl:p-3 hidden xl:flex">
          <p class="p-2" v-if="user && user.email">{{ user.email }}</p>
          <div class="flex items-center mx-2 login-purple-text" v-if="!ai_sid">
            <div><img class="block h-auto mx-auto object-contain mr-1" src="@/assets/image/gept/star.png" alt=""></div>
            <p><span class="text-sm">{{ remainPoints }}</span>點</p>
          </div>
          <a class="inline-block p-2 cursor-pointer" @click="logout2()" v-if="!ai_sid">登出</a>
        </div>
      </div>
    </div>
    <div class="w-full Sidebar-outer fixed z-50 xl:hidden gept_main_bg" v-if="isShowMenu">
      <Sidebar :menuData="menuData" class="max-w-full sidebar" v-on:closeMenu="isShowMenu = false" />
    </div>

    <!-- <Sidebar /> -->
  </header>
</template>

<script>
import { mapGetters } from 'vuex'
import Sidebar from '@/components/GEPT/sidebar'
export default {
  name: 'headerSection',
  props: {
    menuData: {
      type: Object
    }
  },
  computed: {
    ...mapGetters([
      'authorized',
      'remainPoints',
      'ai_sid',
      'ai_uuid',
      'lang',
      'level',
      'user'
    ]),

    urlPath () {
      return 'https://aieta.liveabc.com/study_records.php'
    },
    levelPath () {
      if (this.$route.params.practice_type === 'speaking') {
        return 'https://aieta.liveabc.com/?list_gept_speaking_1'
      }
      return 'https://aieta.liveabc.com/?list_gept_speaking_2'
    }
  },
  components: {
    Sidebar
  },
  data () {
    return {
      isShowMenu: false
    }
  },
  mounted () {
  },
  watch: {
  },
  methods: {
    logout () {
      this.$store.dispatch('logout')
    },
    logout2 () {
      this.$store.dispatch('logout')
      this.$router.replace({ name: 'login' })
    }
  }
}
</script>
<style lang="scss" scoped>
.login-purple-text {
  color: #BC00EB;
}
.Sidebar-outer {
  top: 65px;
  height: calc(100vh - 65px);
  overflow-y: scroll;
  .sidebar {
    height: 100%;
  }
}
.ham-outer {
  width: 50px;
  height: 50px;
  align-items: center;
  display: flex;
  height: 100%;
  overflow: hidden;
}
.ham {
  cursor: pointer;
  -webkit-tap-highlight-color: transparent;
  transition: transform 400ms;
  -moz-user-select: none;
  -webkit-user-select: none;
  -ms-user-select: none;
  user-select: none;
}
.hamRotate.active {
  transform: rotate(45deg);
}
.hamRotate180.active {
  transform: rotate(180deg);
}
.line {
  fill:none;
  transition: stroke-dasharray 400ms, stroke-dashoffset 400ms;
  stroke:#000;
  stroke-width:5.5;
  stroke-linecap:round;
}
.ham1 .top {
  stroke-dasharray: 40 139;
}
.ham1 .bottom {
  stroke-dasharray: 40 180;
}
.ham1.active .top {
  stroke-dashoffset: -98px;
}
.ham1.active .bottom {
  stroke-dashoffset: -138px;
}
</style>